import { useCallback, useState } from 'react';

export function useToggle(initialState = false): [boolean, () => void, (value: boolean) => void] {
    const [state, setState] = useState(initialState);
    const toggle = useCallback(() => setState(currentState => !currentState), []);

    return [state, toggle, setState];
}
